import { useSelector } from "react-redux";
import KeyField from "./KeyField";
import { App } from "antd";
import { User } from "@version2/domain-package";
import type { UserDocSelector, UserDocState } from "./types";
import { defaultUserDocSelector } from "./types";

type UserKeyFieldProps = {
	userDocSelector?: UserDocSelector;
	licenseKey?: string;
};

const UserKeyField = ({ userDocSelector, licenseKey }: UserKeyFieldProps) => {
	const { message } = App.useApp();
	const selector = userDocSelector ?? defaultUserDocSelector;
	const userDoc = useSelector<UserDocState, User | null>(selector);
const keyValue = userDoc?._.licenseKey ?? licenseKey;

	return (
		<KeyField
			value={keyValue}
			placeholder="No key set"
			message={message}
		/>
	);
};

export default UserKeyField;
